import * as types from './mutation-types'

export default {
  [types.LOAD_DOORS](state, data) {
    state.doors = data.data
  },
}
